import { Icon, LoadingSpinner } from "@newsela/angelou";
import { TrendLevel } from "@/reports/types";
import {
  blueIconCss,
  containerCss,
  trendLoadingSpinnerCss,
} from "./WeeklyTrendLevel.style";
import { TREND_LEVEL_ICONS, TREND_LEVEL_TEXT } from "./constants";

interface Props {
  trendLevel: TrendLevel;
  isLoading?: boolean;
}

const WeeklyTrendLevel = ({ trendLevel, isLoading }: Props) => {
  const trendingText =
    TREND_LEVEL_TEXT[trendLevel] ?? TREND_LEVEL_TEXT[TrendLevel.None];
  const trendingIconSvg =
    TREND_LEVEL_ICONS[trendLevel] ?? TREND_LEVEL_ICONS[TrendLevel.None];

  return (
    <div css={containerCss}>
      {isLoading ? (
        <LoadingSpinner __cssFor={{ root: trendLoadingSpinnerCss }} />
      ) : (
        <Icon SvgComponent={trendingIconSvg} __cssFor={{ root: blueIconCss }} />
      )}
      <p>{isLoading ? TREND_LEVEL_TEXT.Loading : trendingText}</p>
    </div>
  );
};

export default WeeklyTrendLevel;
